import context from 'static/script/app/ui/checkout2/context/context';
import observable from 'static/script/app/ui/checkout2/context/observable';
riot.tag2('swish-app2app-modal-body', '<div class="swish-modal-body"> <div if="{!model.isAutoStartAllowed}"> <div class="swish-modal-body-center"> <img riot-src="{this.model.qrCode}"> </div> <div style="display:flex; margin-bottom: 1rem;"> <div style="flex-basis:20%"></div> <div style="flex-basis:60%"> <ol class="formatted swish-modal-content-instructions2"> <li>Öppna Swish-appen.</li> <li>Scanna QR-koden.</li> <li>Signera betalningen som vanligt.</li> </ol> </div> <div style="flex-basis:20%"></div> </div> <div class="swish-modal-body-center"> <div> <a class="link" href="" onclick="{showOtherOptions}">Kan du inte använda QR-koden?</a> <div if="{this.otherOptionVisible}" style="display: block; margin-top: 1rem;"> <label for="phone_number" class="swish-number-label2">Vi skickar en länk till din telefon,<br>klicka på länken för att fullfölja betalningen.</label><br> <input type="text" id="phone_number" maxlength="15" placeholder="exempel:0745010203" class="input-text swish-number-input2" onkeypress="return event.charCode >= 48 && event.charCode <= 57" oninput="{validatePhoneNumber}"> <button class="primary-action-rounded {disabled-action:!phoneNumberValid}" style="width: 12rem; line-height: 2.8rem;" onclick="{sendApp2AppLink}">Skicka länk</button> <div if="{this.smsSent}" class="swish-number-label2 " style="color:green">SMS skickat!</div> </div> </div> </div> </div> </div>', '', '', function(opts) {
        this.context = context;
        this.model = opts.model;
        this.otherOptionVisible = false;
        this.phoneNumberValid = false;

        observable.on('payment-swish-app2app-sms-sent', (data) => {
            this.smsSent = true;
            this.update();
        });

        this.showOtherOptions = () => {
            this.otherOptionVisible = !this.otherOptionVisible;
        }

        this.validatePhoneNumber = () => {
            this.smsSent = false;
            if (this.phone_number.value.length >= 8) {
                this.phoneNumberValid = true;

            }
            else {
                this.phoneNumberValid = false;
            }
            this.update();
        }

        this.sendApp2AppLink = () => {
            if (!this.phoneNumberValid)
                return;
            this.smsSent = false;
            this.context.observable.trigger('payment-swish-app2app-sms',
                {
                    phoneNumber: this.phone_number.value,
                    purchaseOrderId: this.model.purchaseOrderId
                });
        }
});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-app2app-modal-body.riot.html